export enum FormRowType {
    Text = "Text",
    Note = "Note",
    Email = "Email",
    Date = "Date",
    DateTime = "DateTime",
    Time = "Time",
    DateRange = "DateRange",
    Integer = "Integer",
    Float = "Float",
    Choice = "Choice",
    Boolean = "Boolean",
    Password = "Password",
    Location = "Location",
    CurrentLocation = "CurrentLocation",
    FilterChoice = "FilterChoice",
    Suggestions = "Suggestions",
    TranslatableSuggestions = "TranslatableSuggestions",
    File = "File",
    Files = "Files",
    Image = "Image",
    Markdown = "Markdown",
    ViewCell = "ViewCell",
    Signature = "Signature",
    SeatingPlan = "SeatingPlan",
    Color = "Color",
    Translations = "Translations",
    Telephone = "Telephone",
    BankAccount = "BankAccount",
    UnlimitedFile = "UnlimitedFile",
    Link = "Link"
}
